/**
 *    Datepicker connected
 */

import moment from 'moment';
import 'daterangepicker';

(function ($) {
  // @todo warum geht er hier nicht rein!?
  Drupal.behaviors.datepickerCalendar = {
    attach(context, settings) {
      const $datepickerWrap = $('.vb-connected-inline-datepicker');
      const $datepickerPlaceholder = $('.vb-connected-inline-datepicker__text--placeholder');
      const $scrollContainer = $('.vb-mobile-modal--date .vb-mobile-modal__content');
      const $datepickerStart = $datepickerWrap.find('input[name="date[min]"]');
      const $datepickerEnd = $datepickerWrap.find('input[name="date[max]"]');
      let scrollPosition = 0;

      const $triggerButtonDesktop = $('.vb-connected-inline-datepicker__button--toggle:not(.vb-active)');
      const $triggerButtonMobile = $('.vb-mobile-modal__button[href="#vb-mobile-modal--date"]');
      const $clearButton = $('.vb-connected-inline-datepicker__button--clear');
      const $closeButton = $('.vb-connected-inline-datepicker__button--close');

      let locale = {};
      let ranges = {
        Today: [moment()],
        '14 days': [moment(), moment().add(14, 'days')],
        Month: [moment(), moment().endOf('month')],
        Year: [moment(), moment().endOf('year')],
      };

      if (document.documentElement.lang === 'de') {
        ranges = {
          Heute: [moment()],
          '14 Tage': [moment(), moment().add(14, 'days')],
          Monat: [moment(), moment().endOf('month')],
          Jahr: [moment(), moment().endOf('year')],
        };

        locale = {
          daysOfWeek: [
            'So',
            'Mo',
            'Di',
            'Mi',
            'Do',
            'Fr',
            'Sa',
          ],
          monthNames: [
            'Januar',
            'Februar',
            'März',
            'April',
            'Mai',
            'Juni',
            'Juli',
            'August',
            'September',
            'Oktober',
            'November',
            'Dezember',
          ],
          firstDay: 1,
        };
      }

      const $datepicker = $('#vb-connected-inline-datepicker__input--single').daterangepicker({
        autoApply: true,
        parentEl: '#daterangepicker-container',
        showCustomRangeLabel: false,
        ranges,
        locale,
        alwaysShowCalendars: true,
        minDate: moment(),
        // startDate: moment(),
        // endDate: '01/06/2020',
      }, (start, end) => {
        // output date to the placeholder
        if (start.format('DD.MM.YYYY') === end.format('DD.MM.YYYY')) {
          $datepickerPlaceholder.html(start.format('DD.MM.YYYY'));
        } else {
          $datepickerPlaceholder.html(`${start.format('DD.MM.YYYY')} - ${end.format('DD.MM.YYYY')}`);
        }

        // output date to the inputs
        $datepickerStart.val(start.format('DD.MM.YYYY'));
        $datepickerEnd.val(`${end.format('DD.MM.YYYY')} 23:59:59`);

        // set scroll position
        scrollPosition = $scrollContainer.scrollTop();
      });

      // on hide
      $datepicker.on('hide.daterangepicker', (event, picker) => {
        // fix auto close
        if ($datepickerWrap.hasClass('vb-active')) {
          // show datepicker again
          setTimeout(() => {
            // show datepicker again
            $datepicker.data('daterangepicker').show();
          }, 0);
        }

        // scroll to correct position
        setTimeout(() => {
          // scroll to the 'old' position
          $scrollContainer[0].scrollTo(0, scrollPosition);
        }, 0);
      });

      const activateA11y = function () {
        setTimeout(() => {
          // role=button is not allowed on element 'li' :(
          // // a11y
          // $datepickerWrap.find('.ranges li')
          //   .attr('role', 'none');
          //
          // // a11y
          $datepickerWrap.find('.ranges li').attr({
            // 'role': 'button',
            tabindex: '0',
          });

          // a11y
          $datepickerWrap.find('.available').attr({
            role: 'button',
            tabindex: '0',
          });

          // a11y
          $datepickerWrap.find('.table-condensed')
            .attr('role', 'none');

          // focus trap
          Foundation.Keyboard.trapFocus($datepickerWrap);
        }, 100);
      };

      // on
      $datepicker.on('show.daterangepicker', (event, picker) => {
        activateA11y();
      });

      // close on esc button press
      $(document.body).on('keydown', (event) => {
        if (event.key === 'Escape') {
          $('.vb-connected-inline-datepicker.vb-active .vb-connected-inline-datepicker__button--close').trigger('click');
        }
      });

      // load initial date ranges
      if ($datepickerStart.val() !== '' && $datepickerEnd.val() !== '') {
        const start = moment($datepickerStart.val(), 'DD.MM.YYYY');
        const end = moment($datepickerEnd.val(), 'DD.MM.YYYY');

        $datepicker.data('daterangepicker').setStartDate(start.format('MM/DD/YYYY'));
        $datepicker.data('daterangepicker').setEndDate(end.format('MM/DD/YYYY'));

        if (start.format('DD.MM.YYYY') === end.format('DD.MM.YYYY')) {
          $datepickerPlaceholder.html(start.format('DD.MM.YYYY'));
        } else {
          $datepickerPlaceholder.html(`${start.format('DD.MM.YYYY')} - ${end.format('DD.MM.YYYY')}`);
        }
      }

      // show picker on load
      $datepicker.data('daterangepicker').show();

      const clearDatepicker = function () {
        const $dates = $datepickerWrap.find('.calendar-table td.active, .calendar-table td.in-range');
        const $additionalButton = $datepickerWrap.find('.ranges li.active');

        // clear inputs
        $datepickerStart.val('');
        $datepickerEnd.val('');

        // remove 'active' class from 'today'!
        $dates.removeClass('active in-range');

        // remove 'active' class from additional 'today' button!
        $additionalButton.removeClass('active');

        // reset placeholder
        $datepickerPlaceholder.html($datepickerPlaceholder.data('placeholder'));

        // click the 'additional today' button
        $additionalButton.on('click', () => {
          const date = new Date();
          const dateFormatted = `${date.getDate()}.${date.getMonth() + 1}.${date.getFullYear()}`;

          // output date to the inputs
          $datepickerStart.val(dateFormatted);
          $datepickerEnd.val(`${dateFormatted} 23:59:59`);
        });
      };

      // show datepicker 'container'
      $triggerButtonDesktop.add($triggerButtonMobile).on('click', () => {
        $datepickerWrap.toggleClass('vb-active');
        $datepicker.data('daterangepicker').show();

        // a11y
        $(document).on('keyup', '.available:not(.prev):not(.next)', function (event) {
          if (event.key === 'Enter') {
            // trigger mouse action
            $(this).trigger('mousedown');

            // a11y
            activateA11y();
          }
        });

        // a11y
        $(document).on('keyup', '.available.prev, .available.next', function (event) {
          if (event.key === 'Enter') {
            // trigger mouse action
            $(this).trigger('click');

            // a11y
            activateA11y();
          }
        });

        // no date set on startup?
        if ($datepickerStart.val() === '' && $datepickerEnd.val() === '') {
          clearDatepicker();
        }
      });

      // click outside to close the options
      $(document).on('mouseup touchstart', (event) => {
        // trigger button click
        if ($(event.target).hasClass('vb-connected-inline-datepicker__button--toggle')) {
          return false;
        }

        // container
        if (
          !$datepickerWrap.is(event.target) // if the target of the click isn't the container...
                    && $datepickerWrap.has(event.target).length === 0 // ... nor a descendant of the container
        ) {
          $datepickerWrap.removeClass('vb-active');
          $datepicker.data('daterangepicker').show();
        }
      });

      // click 'clear' button
      $clearButton.on('click', () => {
        clearDatepicker();
      });

      // click 'close' button
      $closeButton.on('click', () => {
        $datepickerWrap.removeClass('vb-active');
      });
    },
  };
}(jQuery, Drupal));

// end of datepicker--connected.js
